import { render, staticRenderFns } from "./KezTextarea.vue?vue&type=template&id=16eb90b5&scoped=true&"
import script from "./KezTextarea.vue?vue&type=script&lang=js&"
export * from "./KezTextarea.vue?vue&type=script&lang=js&"
import style0 from "./KezTextarea.vue?vue&type=style&index=0&id=16eb90b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eb90b5",
  null
  
)

component.options.__file = "KezTextarea.vue"
export default component.exports